import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiSearch, FiStar } = FiIcons;

const steps = [
  {
    number: '01',
    title: 'Share Your Current Setup',
    desc: 'Securely provide details about your existing payment processes.',
    icon: FiLock
  },
  {
    number: '02',
    title: 'Get a Tailored Audit',
    desc: "We'll pinpoint efficiencies and compliance solutions for your practice.",
    icon: FiSearch
  },
  {
    number: '03',
    title: 'Elevate Your Payments with Alex',
    desc: 'Experience dedicated support and transparent solutions, built for excellence.',
    icon: FiStar
  }
];

export default function GlobalFooter() {
  const logoUrl = "https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/7ddd4e67fb490c42fb4d56deed5c8910.png";

  return (
    <footer className="bg-white py-24 md:py-32 border-t border-gray-100 relative overflow-hidden">
      
      {/* Background subtle decoration */}
      <div className="absolute bottom-0 w-full h-1/2 bg-gradient-to-t from-sage-lightest to-transparent z-0"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 relative z-10">
        
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-3xl md:text-5xl font-bold text-deepNavy tracking-tight mb-6">
            Your Simple Path to Elevated Payments
          </h2>
          <p className="text-xl text-deepNavy-light font-light leading-relaxed">
            Transitioning your payment processing shouldn't be a headache. We handle the heavy lifting so you can focus on growth.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 relative mb-24">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-[48px] left-[16%] right-[16%] h-px bg-sage-light"></div>
          
          {steps.map((step, idx) => (
            <div key={idx} className="relative z-10 flex flex-col items-center text-center group">
              <div className="w-24 h-24 rounded-3xl bg-white shadow-apple border border-sage-light flex items-center justify-center mb-8 transition-all duration-300 group-hover:-translate-y-2 group-hover:shadow-apple-hover group-hover:border-sage">
                <SafeIcon icon={step.icon} className="w-10 h-10 text-mutedBlue group-hover:text-sage transition-colors duration-300" />
              </div>
              <span className="text-sage font-bold text-sm tracking-widest mb-4">
                STEP {step.number}
              </span>
              <h3 className="text-2xl font-semibold text-deepNavy mb-4">
                {step.title}
              </h3>
              <p className="text-deepNavy-lighter text-lg leading-relaxed font-light">
                {step.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-center justify-center border-t border-gray-100 pt-16">
          <img src={logoUrl} alt="Sunset Swipe" className="h-24 md:h-32 object-contain opacity-80 hover:opacity-100 transition-opacity duration-300" />
          <p className="mt-8 text-sm text-deepNavy-lighter font-light">
            © {new Date().getFullYear()} Sunset Swipe. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}